/**
 * MM-DD形式の日付をMM月DD日のフォーマットに直す関数
 * @param date 日付
 * @returns string
 */
export function dateFormatter(date: string):string {
  // 与えられた日付データを元にDateを宣言
    const d = new Date(date);
    // ja-JPフォーマットで月日のstringに変換
    return d.toLocaleDateString("ja-JP", { month: "short", day: "numeric" });
  }